import {useEffect, useState} from 'react'
import {FormLabel} from 'react-bootstrap'
import Select, {GroupBase, SingleValue} from 'react-select'

interface GrauParentescoOption {
  value: string
  label: string
}

const grauParentescoOptions = [
  {
    label: 'Linha Direta / Familiar',
    options: [
      {value: 'conjuge', label: 'Conjuge / Companheiro(a)'},
      {value: 'mae', label: 'Mae'},
      {value: 'pai', label: 'Pai'},
      {value: 'filho', label: 'Filho'},
      {value: 'filha', label: 'Filha'},
      {value: 'irmao', label: 'Irmão'},
      {value: 'irma', label: 'Irmã'},
    ],
  },
  {
    label: 'Ascendentes / Descendentes',
    options: [
      {value: 'avo', label: 'Avo / Avo'},
      {value: 'neto', label: 'Neto'},
      {value: 'neta', label: 'Neta'},
      {value: 'bisavô', label: 'Bisavô'},
      {value: 'bisavó', label: 'Bisavó'},
      {value: 'bisneto', label: 'Bisneto'},
      {value: 'bisneta', label: 'Bisneta'},
    ],
  },
  {
    label: 'Colaterais',
    options: [
      {value: 'tio', label: 'Tio'},
      {value: 'tia', label: 'Tia'},
      {value: 'sobrinho', label: 'Sobrinho'},
      {value: 'sobrinha', label: 'Sobrinha'},
      {value: 'primo', label: 'Primo'},
      {value: 'prima', label: 'Prima'},
    ],
  },
  {
    label: 'Por Afinidade',
    options: [
      {value: 'sogro', label: 'Sogro'},
      {value: 'sogra', label: 'Sogra'},
      {value: 'genro', label: 'Genro'},
      {value: 'nora', label: 'Nora'},
      {value: 'cunhado', label: 'Cunhado'},
      {value: 'cunhada', label: 'Cunhada'},
      {value: 'enteado', label: 'Enteado'},
      {value: 'enteada', label: 'Enteada'},
      {value: 'padrasto', label: 'Padrasto'},
      {value: 'madrasta', label: 'Madrasta'},
    ],
  },
  {
    label: 'Outros',
    
      
    options: [{value: 'outros', label: 'Outros / Nenhum'},
      {value: 'proprietario', label: 'Proprietário'},
      {value: 'funcionario', label: 'Funcionário'}


    ],
  },
]

const flatGrauParentescoOptions = grauParentescoOptions.flatMap((group) => group.options)

interface Props {
  SetValueParentesco: (value: string) => void
  valueParentesco?: string
  disabled?: boolean
}

export function GetGrauParentesco({
  SetValueParentesco,
  valueParentesco = '',
  disabled = false,
}: Props) {
  const [parentesco, setParentesco] = useState(valueParentesco)

  useEffect(() => {
    setParentesco(valueParentesco || '')
  }, [valueParentesco])

  return (
    <div className='form-group'>
      <FormLabel className='form-label'>Grau parentesco</FormLabel>
      <Select
        value={flatGrauParentescoOptions.find((item) => item.value === parentesco) || null}
        options={grauParentescoOptions}
        onChange={(option: SingleValue<GrauParentescoOption>) => {
          const value = option?.value || ''
          setParentesco(value)
          SetValueParentesco(value)
        }}
        name='parentesco'
        placeholder='Selecione uma opção'
        isDisabled={disabled}
        isClearable
      />
    </div>
  )
}
